<template>
  <div
    v-editable="blok"
    class="pill"
    :class="[blok.font?.font.value || 'pill--default-font', blok.size && `pill--${blok.size}`]"
    :style="pillStyle"
  >
    {{ blok.text }}
  </div>
</template>

<script lang="ts" setup>
import type { SbPillStoryblok } from '@/types'

interface Props {
  blok: SbPillStoryblok
}
const props = defineProps<Props>()

const pillStyle = computed(() => ({
  color: props.blok.color?.value,
  backgroundColor: props.blok.background_color?.value,
  ...(props.blok.border_color?.value
    ? { border: `1px solid ${props.blok.border_color.value}` }
    : {}),
  ...(props.blok.border_radius != null
    ? { borderRadius: `${props.blok.border_radius}px` }
    : {}),
}))
</script>

<style lang="scss" scoped>
.pill {
  display: inline-block;
  width: auto;
  padding: 4px 12px;
  border-radius: 9px;

  &--default-font {
    font-size: var(--font-size-paragraph-2xs);
    font-weight: 600;
    line-height: 16px;
    text-transform: uppercase;
  }

  &--small {
    padding: 4px 8px;
  }

  &--big {
    padding: 8px 16px;
  }
}
</style>
